import * as React from 'react';
import PropTypes from 'prop-types';
import { Notification } from './Notification';

export const NotificationContext = React.createContext(null);

export const useNotification = () => React.useContext(NotificationContext);

export const NotificationServiceProvider = ({ children }) => {
  const [notificationState, setNotificationState] = React.useState(null);

  /**
   *
   * @param {String} options.variant - describes the style one OF (error, warning, info, success)
   * @param {String} options.description - describes the text content of the notification
   */
  const openNotification = options => {
    setNotificationState(options);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setNotificationState(null);
  };

  return (
    <NotificationContext.Provider value={openNotification}>
      <Notification
        open={Boolean(notificationState)}
        onClose={handleClose}
        {...notificationState}
      />
      {children}
    </NotificationContext.Provider>
  );
};
NotificationServiceProvider.propTypes = {
  children: PropTypes.node
};
